import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateNewsPostV1, GK } from 'ck-queries';
import { createFormData, fetchWithErrorThrowing } from 'ck-utils';

import toast from 'react-hot-toast';

export const useNewsCreate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateNewsPostV1) =>
      toast.promise(postCreateNews(data), {
        loading: 'Laddar...',
        success: 'Nyheten har skapats',
        error: 'Kunde inte skapa nyheten',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(GK.news);
    },
  });
};

async function postCreateNews(data: CreateNewsPostV1) {
  const formData = createFormData(data);

  return fetchWithErrorThrowing('/news-posts', {
    method: 'POST',
    body: formData,
  });
}
